export const PRIMARY_COLOR = '#B5CA7D';
export const SECONDARY_COLOR = '#FF725E';
